import hotkeys from 'hotkeys-js';
import { useCallback, useEffect } from "react";
export function useHotkeys(keys, callback, deps = []) {
    const memoisedCallback = useCallback(callback, deps);
    useEffect(() => {
        hotkeys(keys, memoisedCallback);
        return () => hotkeys.unbind(keys, memoisedCallback);
    }, [memoisedCallback]);
}
